// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer'; // 导入 Footer 组件
import Posts from './Pages/Posts';
import WritePost from './Pages/WritePost';
import Home from './Pages/Home';
import Archive from './Pages/Archive';
import About from './Pages/About';
import PostCard from './components/PostCard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/posts" element={<Posts />} />
            <Route path="/write" element={<WritePost />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/about" element={<About />} />
            <Route path="/postcard" element={<PostCard />} />
            {/* 可以添加更多路由 */}
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;